import { cn, SHIMMER_CLASSES } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Accordion } from '@ui/themed';
import { Children } from 'react';
import { ChecklistRootContext } from '../context/root-context';
import type { ChecklistProps } from '../types';
import { ChecklistItem } from './checklist-item';
import { ChecklistProgressHeader, ChecklistProgressHeaderSkeleton } from './progress-header';
import { useChecklistController } from './use-checklist-controller';

export function Checklist(props: ChecklistProps) {
  const { ctx, settled, progress } = useChecklistController(
    {
      onItemComplete: props.onItemComplete,
      onCompletedChange: props.onCompletedChange,
      onAllComplete: props.onAllComplete,
    },
    props.storageKey,
    props.gated,
  );

  return (
    <ChecklistRootContext.Provider value={ctx}>
      {props.progress ? (
        settled ? (
          <ChecklistProgressHeader
            config={props.progress}
            completed={progress.completed}
            total={progress.total}
            actions={props.actions}
          />
        ) : (
          <ChecklistProgressHeaderSkeleton total={Children.count(props.children)} />
        )
      ) : (
        props.actions && <div className="flex flex-wrap justify-end gap-2">{props.actions}</div>
      )}
      {props.progress?.footer &&
        (settled ? (
          props.progress.footer
        ) : (
          <div className={cn('mt-4 h-4 w-1/3 rounded', SHIMMER_CLASSES)} />
        ))}
      {!settled && <Accordion.Skeleton count={Children.count(props.children)} />}
      {/* Kept mounted while gating so item status queries + registration run. */}
      <div hidden={!settled}>
        <Accordion>{props.children}</Accordion>
      </div>
    </ChecklistRootContext.Provider>
  );
}

Checklist.Item = ChecklistItem;
